/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Drive_Tab_Not_FoundInputs */

const fr_api_drive_tab_not_found = /** @type {(inputs: Api_Drive_Tab_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’onglet choisi n’existe plus. Sélectionnez un autre onglet dans les paramètres Drive.`)
};

const en_api_drive_tab_not_found = /** @type {(inputs: Api_Drive_Tab_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The selected tab no longer exists. Choose another tab in Drive settings.`)
};

/**
* | output |
* | --- |
* | "The selected tab no longer exists. Choose another tab in Drive settings." |
*
* @param {Api_Drive_Tab_Not_FoundInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_drive_tab_not_found = /** @type {((inputs?: Api_Drive_Tab_Not_FoundInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Drive_Tab_Not_FoundInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_drive_tab_not_found(inputs)
	return fr_api_drive_tab_not_found(inputs)
});